import React, { useState, useEffect } from 'react';
import '../css files/Home.css';
import logo from '../img/icon.png';

const TypingAnimation = ({ text, typingSpeed }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [isTyping, setIsTyping] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (isTyping) {
        if (currentIndex < text.length) {
          setDisplayedText((prevText) => prevText + text[currentIndex]);
          setCurrentIndex((prevIndex) => prevIndex + 1);
        } else {
          setIsTyping(false);
          setTimeout(() => {
            setIsTyping(false);
          }, 3000); // Pause for 3 seconds before deleting
        }
      } else {
        if (currentIndex >= 0) {
          setDisplayedText((prevText) => prevText.slice(0, -1));
          setCurrentIndex((prevIndex) => prevIndex - 1);
        } else {
          setIsTyping(true);
          setCurrentIndex(0);
        }
      }
    }, typingSpeed);

    return () => clearInterval(interval);
  }, [text, typingSpeed, currentIndex, isTyping]);

  return <span>{displayedText}</span>;
};

const Home = () => {
  return (
    <div className="Containerr">
      <div className="text">
        <h2>Welcome to my portfolio</h2>
        <h1>Hi! I'm Mohamed</h1>
        <p style={{textAlign:'center'}}>
          I<TypingAnimation text=" am a software developer" typingSpeed={100} />
        </p>
      </div>
      <div className="iconImg">
        <img src={logo} style={{ width: '300px', height: '300px' }} alt="Logo" />
      </div>
    </div>
  );
};

export default Home;
